export enum PageContext {
  Campaign = 'CAMPAIGN',
  Shared = 'SHARED',
  Candidate = 'CANDIDATE',
  Home = 'HOME',
  RobinJrHome = 'ROBIN_JR_HOME',
  RatedCandidates = 'RATED_CANDIDATES',
  CentralInbox = 'CENTRAL_INBOX',
  Other = 'OTHER',
}
